import axios from 'axios';

/**
 * Fetch user groups from external API for external users
 * This is used for B2C authenticated users
 */
export const fetchUserGroups = async (objectId: string): Promise<string[]> => {
  try {
    console.log("Fetching groups for objectId:", objectId);

    const response = await axios.post(
        'https://getsharedgroups.azurewebsites.net/api/b2cprdgetgroup?code=nZUNYFCBepK7UjifDljsDDn-aJS-UWokVbvvo3apTvCOAzFuQ5mWuA==',
        {
          objectId: objectId
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
    );

    console.log("Groups API response:", response.data);

    // Extract group names from the response
    const groupNames = response.data.groupNames || response.data.groups || [];
    return groupNames;

  } catch (error) {
    console.error("Error fetching user groups:", error);
    // Return empty array on error, or you could return parsed.groupNames as fallback
    return [];
  }
};

/**
 * Fetch Microsoft Graph groups for internal users
 * This is used for Azure AD authenticated users
 */
export const fetchMicrosoftGraphGroups = async (accessToken: string): Promise<string[]> => {
  try {
    const fetchMemberOf = async (url: string | URL | Request) => {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.json();
    };

    const memberOfUrl = 'https://graph.microsoft.com/v1.0/me/memberOf';
    let graphResponse = await fetchMemberOf(memberOfUrl);
    let graphGroup = graphResponse.value;

    while (graphResponse["@odata.nextLink"]) {
      try {
        graphResponse = await fetchMemberOf(graphResponse["@odata.nextLink"]);
        graphGroup = graphGroup.concat(graphResponse.value);
      } catch (error) {
        console.error('Failed to fetch additional data:', error);
        break;  // Exit the loop if there's an error
      }
    }

    graphGroup = graphGroup.filter((group: any) => group !== undefined);
    const graphGroupsDisplayNames = graphGroup.map((group: {
      displayName: string;
    }) => group.displayName.toLowerCase());
    
    return graphGroupsDisplayNames;
  } catch (error) {
    console.error('Error fetching Microsoft Graph groups:', error);
    return [];
  }
};